import { BreakpointObserver } from '@angular/cdk/layout';

import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  DOCUMENT
} from '@angular/core';
import { ThemeTypes, breakpoints } from '@app/shared/constants';
import { WINDOW } from '@app/shared/utilities/window';

import { SimpleComponent } from '@shared/base-classes';
import {
	FooterCopyrightContentProps,
	FooterCopyrightPresentationProps,
} from '@shared/interfaces';

@Component({
    selector: 'mflooring-footer-copyright',
    templateUrl: './footer-copyright.component.html',
    styleUrls: ['./footer-copyright.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterCopyrightComponent extends SimpleComponent<
	FooterCopyrightContentProps,
	FooterCopyrightPresentationProps,
	any
> {
	public isMobile: boolean = false;
	isMobileSocialIcon = false;
	get themeClass() {
		return `theme-${ThemeTypes.dark}`;
	}
	get copyright() {
		return this.content?.copyright || null;
	}

	get privacyPolicy() {
		return this.content?.privacyPolicy;
	}
	get termsOfUse() {
		return this.content?.termsOfUse;
	}
	get retailStores() {
		return this.content?.retailStores;
	}
	get legalNotice() {
		return this.content?.legalNotice;
	}
	get patent() {
		return this.content?.patent;
	}
	get californiaDisclosures() {
		
		return this.content?.californiaDisclosures;
	}


	get socialIcons(): any[] {
		return (
			!!this.content?.socialMedia &&
			Object.entries(this.content?.socialMedia)
				.map((entry: any) => {
					return {
						name: entry[1].classname,
						imgUrl: entry[1].imgUrl,
						url: entry[1].url,
						order: entry[1].order,
					};
				})
				.sort((a: any, b: any) => {
					return a.order - b.order;
				})
		);
	}

	constructor(
		@Inject(WINDOW) private windowRef: Window,
		private breakpoint: BreakpointObserver,
		@Inject(DOCUMENT) private documentRef: Document,
	) {
		super();
		this.isMobileSocialIcon = this.breakpoint.isMatched(
			breakpoints.mobileMaxfooter
		);
		this.isMobile = this.windowRef.innerWidth < 576;
	}

	@HostListener('window:resize') onResize() {
		this.isMobileSocialIcon = this.breakpoint.isMatched(
			breakpoints.mobileMaxfooter
		);
		this.isMobile = this.windowRef.innerWidth < 576;
	}
	openCookiesPopUp(){
		let cookiesButton=this.documentRef.getElementById("cookies-modal-button");
		cookiesButton.click();
	}
}
